import { buildUrl } from './utils';

const state = {};
const actions = {
  loadAnchorTypes({ rootState: { token } }, { commit }) {
    const url = buildUrl([
      {
        anchors: ''
      },
      {
        types: ''
      }
    ]);
    return this._vm.$http.get(url).then(({ data }) => {
      commit('setAnchorTypes', data, {
        root: true
      });
    });
  },
  getAnchorLinks({ rootState: { token } }, anchor) {
    const url = buildUrl([
      {
        anchors: anchor
      },
      {
        links: ''
      }
    ]);
    return this._vm.$http.get(url).then(({ data }) => Promise.resolve(data));
  },
  createAnchor({ rootState: { token } }, { skillId, id, data }) {
    const url = buildUrl([
      {
        skills: skillId
      },
      {
        nodes: id
      },
      {
        anchors: ''
      }
    ]);

    return this._vm.$http.post(url, data).then(({ data }) => Promise.resolve(data));
  },
  updateAnchor({ rootState: { token } }, { skillId, idNode, idAnchor, data }) {
    const url = buildUrl([
      {
        skills: skillId
      },
      {
        nodes: idNode
      },
      {
        anchors: idAnchor
      }
    ]);
    return this._vm.$http.put(url, data).then(({ data }) => Promise.resolve(data));
  },
  removeAnchor({ rootState: { token } }, { skillId, idNode, idAnchor }) {
    const url = buildUrl([
      {
        skills: skillId
      },
      {
        nodes: idNode
      },
      {
        anchors: idAnchor
      }
    ]);
    return this._vm.$http.delete(url).then(({ data }) => Promise.resolve(data));
  }
};
export default {
  namespaced: true,
  state,
  actions
};
